import { connect } from 'react-redux';

import { requestAuthOtp, verifyAuthOtp, resetMeta, resetPage, getPublishedEvent } from '../../actions/LoginPage';
import LoginVerificationPage from './LoginVerificationPage';

const mapsStateToProps = state => ({
	loginPageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPublishedEvent() {
		dispatch(getPublishedEvent());
	},
	requestAuthOtp(options) {
		dispatch(requestAuthOtp(options));
	},
	verifyAuthOtp(options) {
		dispatch(verifyAuthOtp(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LoginVerificationPage);
